/* eslint-disable default-case */
import produce from 'immer';

import {
  types,
  AuthState,
  AuthActionTypes,
  LoginPayload,
  LoginError,
  LoginPending,
  LoginSuccess,
  UpdateCurrentAdminSuccess,
  UpdateCurrentAdminPayload,
  UpdateCurrentAdminPending,
  UpdateCurrentAdminError,
  ResetPasswordPending,
  ResetPasswordError,
  RequestResetPasswordPending
} from './types';

// Actions
export const actions = {
  login: (payload: LoginPayload): AuthActionTypes => ({ type: types.LOGIN.REQUEST, payload }),
  updateCurrentAdmin: (payload: UpdateCurrentAdminPayload): AuthActionTypes => ({
    type: types.UPDATE_CURRENT_ADMIN.REQUEST,
    payload
  }),
  logout: (): AuthActionTypes => ({ type: types.LOGOUT }),
  requestResetPassword: (payload: string): AuthActionTypes => ({
    type: types.REQUEST_RESET_PASSWORD.REQUEST,
    payload
  }),
  resetPassword: (payload: { token: string; password: string }): AuthActionTypes => ({
    type: types.RESET_PASSWORD.REQUEST,
    payload
  }),
  resetAction: (): AuthActionTypes => ({ type: types.RESET_ACTION }),
  resetError: (): AuthActionTypes => ({ type: types.RESET_ERROR })
};

// Initial State
export const initialState: AuthState = {
  admin: null,
  token: null,
  authenticating: false,
  error: null,
  action: {
    successful: false,
    error: null,
    pending: false
  }
};

// Reducer
export const reducer = (state: AuthState = initialState, action: AuthActionTypes): AuthState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case types.LOGIN.PENDING:
        draft.authenticating = (action as LoginPending).payload;
        break;
      case types.UPDATE_CURRENT_ADMIN.PENDING:
      case types.REQUEST_RESET_PASSWORD.PENDING:
      case types.RESET_PASSWORD.PENDING:
        draft.action.pending = (
          action as UpdateCurrentAdminPending | ResetPasswordPending | RequestResetPasswordPending
        ).payload;
        break;
      case types.LOGIN.SUCCESS:
        draft.token = (action as LoginSuccess).payload.token;
        draft.admin = (action as LoginSuccess).payload.admin;
        draft.error = null;
        break;
      case types.LOGIN.ERROR:
        draft.error = (action as LoginError).payload;
        break;
      case types.UPDATE_CURRENT_ADMIN.ERROR:
      case types.REQUEST_RESET_PASSWORD.ERROR:
      case types.RESET_PASSWORD.ERROR:
        draft.action.error = (action as UpdateCurrentAdminError | ResetPasswordError).payload;
        break;
      case types.LOGOUT:
        draft.token = null;
        draft.admin = null;
        break;
      case types.UPDATE_CURRENT_ADMIN.SUCCESS:
        draft.admin = (action as UpdateCurrentAdminSuccess).payload;
        draft.action.error = null;
        draft.action.successful = true;
        break;
      case types.REQUEST_RESET_PASSWORD.SUCCESS:
      case types.RESET_PASSWORD.SUCCESS:
        draft.action.error = null;
        draft.action.successful = true;
        break;
      case types.RESET_ACTION:
        draft.action = initialState.action;
        break;
      case types.RESET_ERROR:
        draft.error = initialState.error;
        break;
    }
  });
};
